import { useDispatch } from 'react-redux';
import {
    setIsOpen,
    setType,
    setIsLogin,
    showForgotPasswordModal,
    type LoginModalType,
    setRedirectUrl,
} from './reducers/common/login-modal';
import { fetchTmxInfo } from './reducers/common/tmx';
import type { ShellUseDispatch } from './reducers/common';

export const useModal = () => {
    const dispatch = useDispatch<ShellUseDispatch>();

    const openDialog = (
        event: React.MouseEvent | undefined,
        modalType: LoginModalType,
        showLogin: boolean,
        redirectUrl?: string
    ) => {
        if (event) {
            event.preventDefault();
        }
        dispatch(setIsOpen(true));
        dispatch(setType(modalType));
        dispatch(setIsLogin(showLogin));
        if (redirectUrl) {
            dispatch(setRedirectUrl(redirectUrl));
        }
        dispatch(fetchTmxInfo());
    };

    const closeDialog = () => {
        dispatch(setIsOpen(false));
        dispatch(showForgotPasswordModal({ value: false }));
    };

    return { openDialog, closeDialog };
};
